export const CONTINENTS = {
  continent1: {name: 'International'}, continent2: {name: 'Africa'}, 
  continent3: {name: 'Europe'}, continent4: {name: 'Asia'}, 
  continent5: {name: 'South America'}, continent6: {name: 'North America'},
}